import * as React from 'react';
import { SVGProps } from 'react';

const IconKernStrokedSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 13c0 2-2.686 3-6 3s-6-1-6-3V3c0-2 2.686-3 6-3s6 1 6 3v10Zm-2-9.985V2.994c.001-.009.002-.014-.026-.048-.056-.07-.214-.216-.568-.38C10.68 2.233 9.498 2 8 2c-1.498 0-2.68.232-3.406.567-.354.163-.512.31-.568.379-.028.034-.027.04-.026.048V3.015a.136.136 0 0 0 .026.039c.056.07.214.216.568.38C5.32 3.767 6.502 4 8 4c1.498 0 2.68-.232 3.406-.567.354-.163.512-.31.568-.379A.137.137 0 0 0 12 3.015Zm0 2.34C10.938 5.785 9.537 6 8 6s-2.938-.215-4-.645v5.29C5.062 10.215 6.463 10 8 10s2.938.215 4 .645v-5.29Zm0 7.63V13.006c.001.009.002.014-.026.048-.056.07-.214.216-.568.38C10.68 13.767 9.498 14 8 14c-1.498 0-2.68-.232-3.406-.567-.354-.163-.512-.31-.568-.379-.028-.034-.027-.04-.026-.048V12.985a.136.136 0 0 1 .026-.039c.056-.07.214-.216.568-.38C5.32 12.233 6.502 12 8 12c1.498 0 2.68.232 3.406.567.354.163.512.31.568.379a.137.137 0 0 1 .026.039Z"
    />
  </svg>
);
export default IconKernStrokedSizeS;
